<ion-row *cdkVirtualFor="let item of items; let i = index; trackBy: trackItem">
  <ion-col size-xl="12" size-lg="12" size-md="12" size-sm="12" size-xs="12">
    <div
      [class.hide]="item?.itemType !== ItemTypes.group"
      [attr.data-cy]="'list-detail-group-info-section-' + i"
      class="group-info-section"
    >
      <ion-label
        [attr.data-cy]="'list-detail-group-name-text-' + i"
        class="group-name-text"
        [class.small-group-name-text]="isMobile"
      >
        <div class="group-name-wrapper">
          <span class="group-name">{{ item?.groupName }}</span>
          <span
            class="group-count"
            [attr.data-cy]="'list-detail-group-product-count-text-' + i"
          >
            ({{ item?.itemCount }}&nbsp;{{
              (item?.itemCount > 1
                ? 'i18n.lists.products'
                : 'i18n.lists.product'
              ) | translate
            }})
          </span>
        </div>
      </ion-label>
    </div>
    <!-- Primary Product Label Row -->
    <div
      [class.hide]="
        !item?.masterListItem?.isShowingAlternates || !item?.masterListItem
      "
      [attr.data-cy]="'primary-product-section-' + i"
      class="primary-product-section"
    >
      <ion-label
        [attr.data-cy]="'primary-product-text-' + i"
        class="primary-product-text"
      >
        {{ 'i18n.lists.primaryProductLabel' | translate }}
      </ion-label>
    </div>
    <app-usf-product-card-touch
      [class.hide]="
        item?.itemType === ItemTypes.group ||
        listViewMode === ListViewMode.pricing
      "
      id="product-card-{{ i }}"
      [vm]="{
        mode: mode,
        product: item,
        index: listViewMode === ListViewMode.pricing ? 0 : i,
        itemType: item?.itemType,
        list,
        pricingDisabled,
        isOnline,
        isSelected: item.selected,
        checkboxDisabled: item.disabled,
      }"
      [showNotes]="
        (showNotes && listItemNoteFeatureFlag) ||
        (!listItemNoteFeatureFlag &&
          (item?.item?.note || item?.masterListItem?.referenceComment))
      "
      [listItemNoteFeatureFlag]="listItemNoteFeatureFlag"
      (ellipsisEmitter)="emitEllipsisEmitter($event)"
      (infoIconClickEmitter)="emitInfoIconClickEmitter($event)"
      (itemNoteClickEmitter)="emitItemNoteClickEmitter($event)"
      (productCardClickEmitter)="emitProductCardClickEmitter($event)"
      (promotionClickEmitter)="emitPromotionClickEmitter($event)"
      (quantityInputEmitter)="emitQuantityInputEmitter($event)"
      (quantityUpdateEmitter)="emitQuantityUpdateEmitter($event)"
      (declineBetterBuyEmitter)="emitDeclineBetterBuy($event)"
      (acceptSwapEmitter)="acceptSwap($event)"
      (productConversionEmitter)="emitProductConversionEmitter($event)"
    >
      <ion-checkbox
        class="selectable"
        mode="ios"
        *ngIf="
          selectable ||
          (productCardModes.productNumberSearch === mode && !item?.notFound) ||
          item?.masterListItem?.isComparingWithAlternates
        "
        [ngModel]="item.selected"
        (ngModelChange)="handleSelectionChange($event, item)"
        data-cy="product-card-check-box"
        [disabled]="item.disabled"
      >
      </ion-checkbox>
    </app-usf-product-card-touch>
    <!-- Pricing Product Card-->
    <app-usf-pme-product-card
      [index]="listViewMode === ListViewMode.pricing ? i : 0"
      [class.hide]="
        item?.itemType === ItemTypes.group ||
        listViewMode !== ListViewMode.pricing
      "
      [product]="item"
      [isOnline]="isOnline"
      [screenWidth]="screenWidth"
      [platformType]="platformType"
      [showNote]="selectedListType === ListType.normal"
      [hideLowLimit]="hideLowLimit"
      [isSelected]="
        item.item?.listItemKey?.listItemId === selectedListItemKey ||
        item.productNumber === selectedListItemKey
      "
      [isTouch]="true"
      (priceChanged)="emitPriceChanged($event)"
      (clicked)="handlePmeProductClick($event)"
      (infoIconClick)="emitInfoIconClickEmitter($event)"
      (bannerClick)="emitPromotionClickEmitter($event)"
      (itemNoteClick)="emitItemNoteClickEmitter($event)"
      (closeManualApproval)="handleCloseManualApproval($event)"
    >
    </app-usf-pme-product-card>
    <!-- Alternate Products Label Row -->
    <div
      [class.hide]="
        !item?.masterListItem?.isShowingAlternates || !item?.masterListItem
      "
      [attr.data-cy]="'alternate-products-section-' + i"
      class="alternate-products-section"
    >
      <ion-label
        [attr.data-cy]="'alternate-product-text-' + i"
        class="alternate-product-text"
      >
        {{ 'i18n.lists.alternateProductsLabel' | translate }}
      </ion-label>
      <ion-icon
        (click)="emitCollapseAlternates(item)"
        [attr.data-cy]="'alternate-products-chevron-' + i"
        name="chevron-down-outline"
      ></ion-icon>
    </div>
    <!-- Alternate Products Divider -->
    <div
      [class.hide]="!item?.isLastSecondary || !item?.masterListItem"
      [attr.data-cy]="'alternate-product-divider-' + i"
      class="alternate-products-divider"
    >
      <ion-item-divider> </ion-item-divider>
    </div>
  </ion-col>
</ion-row>
